import type { FaireProductEntity } from "../../entity_types/product";

export const p_9pg2v6sxjz: FaireProductEntity = {
  token: "p_9pg2v6sxjz",
  type: "product",
  name: "Pearl Chain Radiant Initial Necklace",
  brandToken: "b_6t4mvvvp2x",
  brandName: "The Sis Kiss",
  imageUrl:
    "https://cdn.faire.com/fastly/b65bb7adcce406c8428715efa3d00843c64e4fe71cda765f069b933dcb6f4762.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4e22688b4148b5e669ca603c43f259e52ed2603fb700f3659340f45f4e9d0cf0.jpeg",
    "https://cdn.faire.com/fastly/81a9b0f7d6d6f14fd4634ab30aac04dda94b73f592d700ce1362e1c461ecf5ba.jpeg",
    "https://cdn.faire.com/fastly/332357bedf313a101c1a1691a1ff2531d9fb19a0c718269e96250cd62d5ee890.jpeg",
  ],
  priceDollars: 23,
  description:
    "Please note these necklaces are on preorder until the end of January 2026. Please note this timeline prior to ordering. Thank you.\n\nDetails \n\n\nMaterial: Faux pearl beads with a 14k gold-plated pendant featuring clear baguette rhinestones. \n\nMSRP: $38.00. Please do not exceed $58.00. \n\nLength: 16 inches, necklace length, with a 2 inch extender \n\n\nPendant: 1 1/2 inch diameter pendant. \n\n\nFinishes: gold or silver\n\nWhy We Love It! \n\nThis unique necklace combines a fan-favorite, the radiant pendant, with a soft faux pearl strand. We created multiple styles in our radiant style simply based on demand and customer requests. We love creating something requested by our original style sisters! Thank you for coming back for more sis. \n\n",
  tags: [],
  msrpDollars: 50.6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:56:08.316Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
